const LABEL_ICONS = {
    "Voir les détails": "eye",
    "Voir ses commandes": "clipboard-list",
    "Modifier": "pencil",
    "Supprimer": "trash",
    "Publier": "upload",
    "Télécharger le reçu (PDF)": "download",
    "Téléchargement…": "download",
    "Annuler la commande": "x-circle",
    "Partager": "share",
    "Masquer l'avis": "eye-off",
    "Rendre visible": "eye",
    "Retirer": "x",
    "Désactiver": "user-minus",
    "Activer": "user-check",
    "Réactiver": "user-check",
    "Marquer supprimé": "trash"
};

const ID_ICONS = {
    view: "eye",
    edit: "pencil",
    delete: "trash",
    publish: "upload",
    cancel: "x-circle",
    share: "share",
    "download-receipt": "download",
    hide: "eye-off",
    show: "eye",
    restore: "eye",
    remove: "x"
};

/**
 * Resolve an inline SVG icon name for a row action or menu item.
 * @param {{ id?: string, label?: string, icon?: string, danger?: boolean }} item
 */
export function iconForAction(item) {
    if (item?.icon) {
        return item.icon;
    }
    if (item?.label && LABEL_ICONS[item.label]) {
        return LABEL_ICONS[item.label];
    }
    if (item?.id && ID_ICONS[item.id]) {
        return ID_ICONS[item.id];
    }
    if (item?.danger) {
        return "trash";
    }
    return null;
}
